import { render, staticRenderFns } from "./sljl.vue?vue&type=template&id=b237de8c&scoped=true&"
import script from "./sljl.vue?vue&type=script&lang=js&"
export * from "./sljl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b237de8c",
  null
  
)

export default component.exports